module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.12.0.0.box.377.589.317.63.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.12.0.0.box.377.589.317.63.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _vm._v("Foreword ")])]), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1.w.0.0.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.191.948.1351.1521.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.0.box.193.948.1349.699.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.0.0.0"
    }
  }), _vm._v("This ")]), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.23.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.24.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.25.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.1.2.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0"
    }
  }), _vm._v("Book, ")]), _vm._v("concerning the history and genealogy of the Casso family in America, was conceived many years ago and was prompted by three dominant factors. The first, of course, was the result of my own curiosity about the origin of the Cassos in Europe and how our life began here in Louisiana. The second was my wish to leave a knowledge with the younger members of our family so that not only the lore but the traditions as well, could be handed down from one generation to another and carried on, with pride, by all the ensuing generations. The third factor was the fact that my late mother, the second Mrs. Joseph Christian Casso (nee Laura Aloysia Babin), had through the years collected much memorabilia which formed a basis on which to start, not only an album but a story as well, featuring the pioneers of our family.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.191.1661.1350.808.q.60"
    }
  }, [_vm._v("She was thorough in her methods, for every photograph, newspaper clipping, and souvenir was duly noted with names, places, and dates. Much credit is due her for her thoughtfulness in preserving for our family so many treasured tokens of the past. She had told me many times that the only things worthwhile in life are those we can pass on to be shared and cherished by others. It is with this spirit that I have assembled the information contained herein, together with the photographs which are not only part of her collection, but which were contributed by many members of our family, notably, Mrs. Mrs. Robert T. Seeds (Grace Eliska Casso), the Capone family, principally Mrs. Herbert Nuessly (Fortunate Capone), Mr. and Mrs. Anthony Capone (Margaret Diaz), Mr. and Mrs. John Capone (Agnes Marie Le Blanc), the Regira family, mainly Mr. and Mrs. Lawrence Regira (Janice Sanchez), and Dr. and Mrs. Leo J. Schoeny (Byrdie Marie Catherine Casso).")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.1.0.box.191.357.1356.2118.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.0.box.191.357.1347.376.q.60"
    }
  }, [_vm._v("The family of the late Mr. and Mrs. John Pfister of Donaldsonville, though not part of the Casso clan, contributed immeasurably by lending me photographs of the Loeb family and helping to identify them. Mrs. John Pfister was Delia Loeb before her marriage and was a sister of Eliska and Bella Loeb, both of whom married Lucien Casso. Each of us should feel a great measure of gratitude to the Pfister family for their help and kindness.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.1.box.195.743.1345.645.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.1.0"
    }
  }), _vm._v("Besides wanting to preserve for posterity the history of our family, I thought its story had many other interesting facets worth mentioning. For as I gathered the information, piecemeal, over the years, it became more and more interesting, and for one who had delved into the field of historical research most of his adult life, I found it to be as fascinating and singular as any family's history that I have come in contact with. It has few parallels in its homogenous and cosmopolitan composition. And I suggest that each of you search your minds or look among your acquaintances and try to find a family that compares with ours for diversity, uniqueness, and above all for harmonious relationships among such contrasting nationalities and religions.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.2.box.198.1396.1345.633.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.2.0"
    }
  }), _vm._v("I have concerned myself, principally, with giving a greater indepth account of the lives of Mr. and Mrs. Lorenzo Casso than I did their children, since they are in fact, the founders of our family in America. I have also given more attention to the husbands of the two daughters of this couple than I did the wives of their sons. The daughters married, and of course their names changed, but the proportion of blood and love remained the same. Consequently the names Casso, Capone, and Regira are synonymous and have an indelible identity with each other, and the story of one without some treatment of the others would be incomplete, since I consider them one and inseparable, for they are indeed the names of the children of Lorenzo and Mathilde Casso.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.3.box.199.2048.1348.427.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.3.0"
    }
  }), _vm._v("The result contained herein is the accumulation of countless hours, days, weeks, and months that stretched into years—years spent trying to draw the curtain from a dark and receding past. I visited graves and mausoleums and searched libraries, courthouses—city, state, and national, and archives, and church records, here and abroad; reviewed newspaper files and interviewed scores of people. I even invited myself to other people's homes, explaining to them what I was trying to accomplish and to gather information or mementos of the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.14.1.0.box.192.349.1348.649.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.0.0"
    }
  }), _vm._v("\npast. This, no doubt, was an inconvenience to them, but be assured it was even more so to me. I corresponded with numerous people here and abroad; my letters had to be translated into Italian, and when I received a letter, it had to be translated into English. On my visits to Europe I found time to take side excursions into cities, towns, and villages, chasing a clue, a hunch, in the hope that at last I had found our European home. In many remote villages, I was the first American ever seen there. Interpreters were hired as I repeated my visits over there to cemeteries, churches, provincial seats of government always hoping that somewhere a slender thread of information would lead to the answer to my ultimate question—where did our family begin in Italy?")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.192.349.1351.2122.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.192.1010.1350.1025.q.60"
    }
  }, [_vm._v("My efforts were rewarding in one sense and utterly frustrating and disappointing in another. I am sorry that I have not found all the answers that I had hoped for, but I became pressed by time, to get the information gathered, organized and on paper, before I too should join our ancestors! I did not want to die without sharing with each of you the knowledge I have obtained up to now. Initially I was going to get all my notes together, in order, have them typed with copies for each of my children and put one copy with my private papers at Louisiana State University. But upon reflection, I thought this to be a most selfish attitude; for after all, isn't this what is wrong with our world today . . . people concerned only with themselves? I decided, instead, that it would be in keeping with the attitude of the generations gone by to share this knowledge with each of you. My work, therefore, is entirely a labor of love, without any recompense whatever, other than the knowledge that I have provided, at least for the younger generation of our family, a history of those who so laboriously and nobly established the cornerstone of our family in Louisiana. I wanted to preserve for each descendant all these memories, for I consider them too precious to let them die with me.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.192.2048.1351.423.q.60"
    }
  }, [_vm._v("This is really more than a history of our family; it represents what mankind has been searching for since the dawn of civilization—a unity among people, a harmony among nations, and an ecumenism among religions. Where does one find a family such as ours, with the Italian, French, Spanish, Jewish, German, and the Anglo-Saxon elements of English, Scot, Welsh, Irish, and Scandinavians, all blended into a happy unit? Where has the Judeo-Christian spirit been more aptly demonstrated than within our own ranks? We have so much to"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.0.box.193.359.1343.429.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.0.0"
    }
  }), _vm._v("\nbe proud of, so much to relate and preserve for our children so that they will know the story of our family and its beginning in America, to hand down to their children and the generations to come. In a world with the perplexing problems of today, it will inspire them to remember that others have persevered through the years, all because one Italian immigrant came to America with a dream, brimming with confidence in his own ability, ready to challenge life in a strange country among strange people, to found the family that is ours.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.1.0.box.193.359.1348.2116.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.1.box.194.799.1343.524.q.60"
    }
  }, [_vm._v("A family is a continuing entity and the basis on which our entire civilization was founded; lest we forget, we are related to each other as our children are related to each other. The compassions, loves, attachments, and concern we feel toward our mothers, fathers, sisters, brothers, husbands, wives, and children are the same emotions sensed by all. Every gamut of emotion was experienced as I probed deeper into the veiled past and gathered, bit by bit, incidents to be woven into a continuing pattern of information. I entered a world gone by, a world with an overwhelming aura of nostalgia which touched the tender nerves of heart and soul.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.2.box.195.1345.1346.969.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.2.0"
    }
  }), _vm._v("Since the present generation is the first to have no knowledge of what life was like before the mechanical age, it became necessary to re-create the exact conditions and environment that existed during Lorenzo and Mathilde's time. This was the most difficult part of the research and it was time consuming. To think that the only means of locomotion then were the horse, mule, donkey, sail, or steamboat or that one simply walked, may be difficult to imagine. Today, we are surrounded by mechanical contrivances and are living in a highly technical age, where we have at least one bus, truck, automobile, motorbike, or motorboat for every person in the United States. But in those days one could hardly exist without his animals, and there were two for each person in the state of Louisiana. As on a great stage, I had to change the scenery putting the animals back in place and removing the gasoline-powered vehicles. It was necessary to create a mental picture of Donaldsonville, the state of Louisiana, and the United States, too, for that matter, into the same rustic or pastoral setting which prevailed, beginning in 1859. It added much length to the manuscript, but I considered it absolutely essential to the story.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.3.box.199.2326.1342.149.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.3.0"
    }
  }), _vm._v("Although I had little direct and positive knowledge concerning the early life of Lorenzo and Mathilde as newlyweds or the infant years of their children, I drew from what was told to me by my elders"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.16.1.0.box.191.350.1348.420.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.0.0"
    }
  }), _vm._v("\nand depended, to a degree, on inferences ranging from certainty to conjecture. I moved step by step, chronologically, in my research of those early years, equating the events in their lives with the certain knowledge of the times. Common sense dictated many presumptions and I was careful to refrain from dramatizing to an extent beyond my honest convictions. It was necessary to dramatize and to create a bit of dialogue in order to give continuity, emphasis, and interest, but this was held to a minimum.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.191.350.1351.2122.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.192.790.1349.975.q.60"
    }
  }, [_vm._v("During the last two years of my father's life, it was my good fortune to be with him constantly. Many evenings either at our home in Donaldsonville or at Salzburg and Cedar Grove plantations, free from intrusion, he recounted his life and that of his mother, father, brothers, and sisters. I felt even then, the importance and value of these occasions, as he told me, as his father and mother had told him, of the early years when he, his brothers, and sisters were becoming young men and women. It was an experience accorded to few people, to have a witness of the spectacular and turbulent era recount in detail the scenes visited. The circumstances of my birth were fortunate, for though I was my mother's firstborn, I was my father's tenth, and my arrival occurred late in his life. Consequently, while most of my contemporaries were learning from their fathers events of their immediate generation, I was hearing about the Gay Nineties, his boyhood spent during the trying days of Reconstruction, and the uncertain economic period that followed. It has been and shall always be what I consider the most important phase of my entire lifetime— those last years spent with Papa.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.2.box.192.1778.1350.694.q.60"
    }
  }, [_vm._v("Of course, the greatest single disappointment of my research was our inability to locate the only known photograph of the father of our family, Lorenzo Casso, which was in the possession of his eldest son, Lucien. Upon my uncle's death it was in the possession of his daughter Royal Casso, and since her demise, we have been unable to find it. It is a treasure of inestimable value and irreplacable. That it did exist is beyond question for there are too many of us alive today who knew of it, saw it, and can readily identify it. Needless to say, until it is found there will always be a restless desire to somehow save it from oblivion. I had intended to use Lorenzo's photograph as the frontispiece of the book, thereby giving each of his descendants the image of their grandfather and the man who founded our family in the New World. Now one can appreciate my haste in getting all the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.1.0.box.192.359.1345.308.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.0.0"
    }
  }), _vm._v("\nvalued pictures of our family copied and into this book, so that a general distribution can be made among all the children of Lorenzo and Mathilde, thereby insuring their existence for all the years to come. I hope that somehow we shall find the picture of our grandfather so that copies can be made and sent to owners of this book at a later date.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.1.0.box.192.359.1350.2112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.1.box.194.688.1343.307.q.60"
    }
  }, [_vm._v("The Casso family's coat of arms was given to me many years ago by my maternal first cousin, Charles Frederick Lucien, who chanced upon it during his travels. I have not been able to ascertain its source or its certain authenticity. It is, nevertheless, an interesting addition to the data already garnered, and we are indebted to him for his contribution.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.2.box.194.1016.1346.585.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.2.0"
    }
  }), _vm._v("In preparing the format for this issue, I encountered many problems, each requiring a lot of time. As I borrowed each old photograph, I had a copy made immediately, and promptly returned the photographs. As is evident, the response for pictures was generous in spirit and value and is testimony to the goodness of the children of Lorenzo and Mathilde. Copying each photograph involved considerable expense, but the caution was worthwhile. There are more of some members of the family than there are of others since some responded more freely than others and I did not want to penalize those who generously submitted their photographs because there were some who did not submit any.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.3.box.195.1613.1344.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.3.0"
    }
  }), _vm._v("My nephew, Conrad Charles Casso, is responsible for the fine reproduction of our family's Coat of Arms which appears in this book. With the exception of the photographs, Conrad copied every piece of my material, facilitating repeated studies and editing. He was most generous with his time and talents. His service to me was indispensable and mere words could not express my appreciation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.4.box.196.1939.1346.479.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.4.0"
    }
  }), _vm._v("The genealogical chart involved considerable time and planning. I left each family the option of submitting the names of their kin in the order of their ages. As far as I know, it is complete. If it is not, the responsibility is beyond my control. I organized the chart into readable and chronological order and entered the information exactly as it was given to me by the various families. In each instance I conferred with senior members of the respective families. The names that appear—even if there are some misspellings—are the ones they preferred.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.5.box.269.2428.1273.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.5.0"
    }
  }), _vm._v("I received help from many people who gave either of their time"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR15.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.0.box.192.346.1349.757.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR15.w.1.0.0"
    }
  }), _vm._v("\nor talents, and I have duly noted them in the acknowledgments. But there are three persons who helped me far beyond normal expectations. Mrs. Robert T. Seeds (Grace Eliska Casso) gathered many of the pictures among the people in the Donaldsonville locale, submitted them to me, and then had to return them. She did much leg work running down various items of information around Donaldsonville, Baton Rouge, Paincourtville, and Plattenville, and many other places in the neighborhood of Ascension Parish. Her boundless enthusiasm, exceptional talents, and reliability rendered a difficult task easier. She never complained about how busy she was and was unstinting in her help. The mother of two children, one a small child, and an aid in her husband's businesses, she still found time to do an incredible amount of work, not only in my behalf but for all our family. She was my right hand, and I shall forever be grateful.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR15.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR15.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR15.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.192.346.1349.2121.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.192.1115.1349.536.q.60"
    }
  }, [_vm._v("Dowen William Fife I is responsible for the splendid map which indicates the origins of the Cassos, Capones, and Regiras in Italy. He also made the map of the city of Donaldsonville with its details showing the places of birth of the second generation of our family which were, of course, the first homes of the children of Lorenzo and Mathilde. Both of these maps were originally prepared by me as rough sketches; Dowen with his fine craftsmanship created the finished product. Needless to say a great amount of time was expended on these two projects, but his enthusiasm equalled his rare gift of draftsmanship.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR15.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.192.1664.1348.639.q.60"
    }
  }, [_vm._v("I am grateful to my wife, Madeleine, who had to put up with cancelled social engagements, lonely weekends at home while I was away gathering information or plying my typewriter in an effort to make the printer's deadline. All things in our home became secondary as she gave priority to my book. Her patience, tolerance, and understanding were exemplary virtues rarely witnessed. It is a great measure of gratitude that I owe her not only for her forebearance but for encouraging me when events beyond my control offered impediments. She made our home a pleasant, quiet place, conducive to the tedious and difficult task of assembling information, organizing it, and then writing this book. It was an arduous chore made easier and more pleasant because of her and the environment she created for me.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR15.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.3.box.193.2317.1348.150.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR15.w.1.3.0"
    }
  }), _vm._v("During the course of my life I have noticed that all things erected by man will crumble in time. Even our cemeteries which are replete with marble and granite tombstones with the names thereon become"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR16.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.0.box.193.356.1342.319.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.0.0"
    }
  }), _vm._v("\nfainter as the years pass. The only things on earth that have been preserved in original forms are the recorded words of man found in literature, written in books or upon tablets or scrolls. Knowing this, I have made an humble attempt to record for posterity the great events in the lives of people whose memory is sacred and dear to us all. I hope it will be a more lasting memorial to people we love.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR16.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.1.0.box.193.356.1343.755.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.1.box.193.687.1343.424.q.60"
    }
  }, [_vm._v("It is my dedicated purpose and wish that all members of our family will be pleased with my efforts. However, let me say that the primary purpose is not so much to please the living as it is to honor the dead. The responsibility for all the contents, other than the information furnished me on the genealogical chart, is mine and mine alone, and I assume that responsibility, for it is a story that had to be related; it must be preserved for all time, and more important, it is our history, and it belongs to each and everyone of us.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR17.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR17.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9676f42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0008.vue
// module id = 57
// module chunks = 0